var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("div", { staticClass: "doc_sb_edit p-3" }, [
    _c("div", { staticClass: "form-group mt-2" }, [
      _c(
        "label",
        { staticClass: "form-label", attrs: { for: "advanced_type" } },
        [_vm._v("\n            Тип\n        ")]
      ),
      _vm._v(" "),
      _c("div", { staticClass: "input-group flex-nowrap" }, [
        _vm._m(0),
        _vm._v(" "),
        _c("input", {
          staticClass: "form-control",
          attrs: { id: "advanced_type", disabled: "", type: "text" },
          domProps: { value: _vm.typeLabel },
        }),
      ]),
    ]),
    _vm._v(" "),
    _vm.has_action
      ? _c("div", { staticClass: "form-group mt-2" }, [
          _c(
            "label",
            { staticClass: "form-label", attrs: { for: "advanced_state" } },
            [_vm._v("\n            Статус\n        ")]
          ),
          _vm._v(" "),
          _c("div", { staticClass: "input-group flex-nowrap" }, [
            _vm._m(1),
            _vm._v(" "),
            _c("input", {
              staticClass: "form-control",
              attrs: { id: "advanced_state", disabled: "", type: "text" },
              domProps: { value: _vm.stateLabel },
            }),
          ]),
        ])
      : _vm._e(),
    _vm._v(" "),
    _c("div", { staticClass: "form-group mt-2" }, [
      _c(
        "label",
        { staticClass: "form-label", attrs: { for: "advanced_created" } },
        [_vm._v("\n            Створено\n        ")]
      ),
      _vm._v(" "),
      _c("div", { staticClass: "input-group flex-nowrap" }, [
        _vm._m(2),
        _vm._v(" "),
        _c("input", {
          staticClass: "form-control",
          attrs: { id: "advanced_created", disabled: "", type: "text" },
          domProps: { value: _vm.createdAtLabel },
        }),
      ]),
    ]),
    _vm._v(" "),
    _c("div", { staticClass: "list_state mt-4" }, [
      _c("h5", { staticClass: "mb-3" }, [_vm._v("Відповіді")]),
      _vm._v(" "),
      _vm.doc.answers_view && _vm.doc.answers_view.length
        ? _c(
            "div",
            _vm._l(_vm.doc.answers_view, function (item) {
              return _c(
                "div",
                {
                  key: item.id,
                  staticClass: "card mb-3 shadow-0 border",
                  class: _vm.answerRiskClass(item),
                },
                [
                  _c("div", { staticClass: "card-body" }, [
                    _c(
                      "div",
                      {
                        staticClass:
                          "d-flex justify-content-between align-items-start flex-wrap",
                      },
                      [
                        _c("div", { staticClass: "pr-3" }, [
                          _c("h6", { staticClass: "mb-1" }, [
                            _vm._v(
                              "\n                                " +
                                _vm._s(item.title) +
                                "\n                            "
                            ),
                          ]),
                          _vm._v(" "),
                          item.description
                            ? _c(
                                "div",
                                { staticClass: "text-muted small mb-2" },
                                [
                                  _vm._v(
                                    "\n                                " +
                                      _vm._s(item.description) +
                                      "\n                            "
                                  ),
                                ]
                              )
                            : _vm._e(),
                          _vm._v(" "),
                          item.group_title
                            ? _c(
                                "div",
                                { staticClass: "small text-info mb-2" },
                                [
                                  _vm._v(
                                    "\n                                " +
                                      _vm._s(item.group_title) +
                                      "\n                            "
                                  ),
                                ]
                              )
                            : _vm._e(),
                        ]),
                        _vm._v(" "),
                        _c(
                          "span",
                          {
                            staticClass: "badge",
                            class: item.answer
                              ? "badge-success"
                              : "badge-secondary",
                          },
                          [
                            _vm._v(
                              "\n                            " +
                                _vm._s(item.answer_text) +
                                "\n                        "
                            ),
                          ]
                        ),
                      ]
                    ),
                    _vm._v(" "),
                    item.comment
                      ? _c("div", { staticClass: "mt-3" }, [
                          _c("label", { staticClass: "form-label mb-1" }, [
                            _vm._v("Коментар"),
                          ]),
                          _vm._v(" "),
                          _c(
                            "div",
                            {
                              staticClass: "alert alert-light border mb-0",
                              staticStyle: { "white-space": "pre-line" },
                            },
                            [
                              _vm._v(
                                "\n                            " +
                                  _vm._s(item.comment) +
                                  "\n                        "
                              ),
                            ]
                          ),
                        ])
                      : _vm._e(),
                  ]),
                ]
              )
            }),
            0
          )
        : _c("div", { staticClass: "text-muted" }, [
            _vm._v("\n            Немає відповідей\n        "),
          ]),
    ]),
  ])
}
var staticRenderFns = [
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("div", { staticClass: "input-group-prepend" }, [
      _c("span", { staticClass: "input-group-text" }, [
        _c("i", { staticClass: "fal fa-typewriter fs-xl" }),
      ]),
    ])
  },
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("div", { staticClass: "input-group-prepend" }, [
      _c("span", { staticClass: "input-group-text" }, [
        _c("i", { staticClass: "fal fa-typewriter fs-xl" }),
      ]),
    ])
  },
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("div", { staticClass: "input-group-prepend" }, [
      _c("span", { staticClass: "input-group-text" }, [
        _c("i", { staticClass: "fal fa-typewriter fs-xl" }),
      ]),
    ])
  },
]
render._withStripped = true

export { render, staticRenderFns }